export default {
  ENROLL_STATUS_0:0,//0 未审核
  ENROLL_STATUS_1:1,//1 录取
  ENROLL_STATUS_2:2,//2 不录取
  ENROLL_STATUS_3:3,//3 面试
  ENROLL_STATUS_4:4,//4 补录
}



// WEBPACK FOOTER //
// ./src/utils/const.js